import { FC } from 'react';
import { useSessionEnrollment } from '@hooks/mutations/useSessionEnrollment';
import { useIntl } from 'react-intl';
import { A11yButton } from '@fe-learner-common';
import { JoinWaitlistButton } from './JoinWaitlistButton';
import { TSessionDetails } from '@api/io/session.io';
import { useEnrollmentError } from '@hooks/feedback/useEnrollmentError';
import { useSessionStates } from '@routes/session-details/hooks/useSessionStates';
import { useEnrollmentFeedback } from '@hooks/feedback/useEnrollmentFeedback';

const PureEnrollButton: FC<{ sessionId: number }> = ({ sessionId }) => {
  const intl = useIntl();

  const {
    mutate: enroll,
    data: enrollmentData,
    isPending,
    error,
  } = useSessionEnrollment({
    sessionId,
  });

  useEnrollmentError(error);
  useEnrollmentFeedback({
    enrollmentStatus: enrollmentData?.status,
    sessionId,
  });

  return (
    <A11yButton
      className="lf:l-btn lf:l-btn-md lf:l-btn-primary"
      isLoading={isPending}
      onClick={() => {
        enroll();
      }}
    >
      {intl.formatMessage({ id: 'catalog.course.action.enroll' })}
    </A11yButton>
  );
};

export const EnrollButton: FC<{ sessionDetails: TSessionDetails }> = ({
  sessionDetails,
}) => {
  const sessionStates = useSessionStates(sessionDetails);
  const waitlistDisabledOrFull =
    !sessionDetails.waitlist.enabled || sessionStates.waitlistFull;

  if (sessionStates.sessionFull && waitlistDisabledOrFull) {
    return null;
  }

  if (sessionStates.sessionFull) {
    return <JoinWaitlistButton sessionId={sessionDetails.id} />;
  }

  return <PureEnrollButton sessionId={sessionDetails.id} />;
};
